import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const StockCarRacing = () => {
  return (
    <SportsLayoutComp name={'Stock Car Racing'}/>
  )
}

export default StockCarRacing